import * as React from "react";
import { PureComponent } from "react";
import { getClassName } from "./functions";

class Glyphicon extends PureComponent<any> {
  render() {
    const { icon, className, title } = this.props;
    return (
      <i className={getClassName(className)} title={title}>
        {icon}
      </i>
    );
  }
}

export default Glyphicon;
